var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5439",
    "data-name": "Group 5439",
    transform: "translate(0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5457",
    "data-name": "Group 5457"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1977",
    "data-name": "Rectangle 1977",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(-0.463)",
    fill: "#e23744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo_00000038394049246713568260000012923108920998390947_",
    d: "M22.441,7.306c.015.22.015.441.015.662A14.5,14.5,0,0,1,7.861,22.563v0A14.517,14.517,0,0,1,0,20.259a10.393,10.393,0,0,0,1.221.074,10.293,10.293,0,0,0,6.37-2.2A5.135,5.135,0,0,1,2.8,14.571a5.131,5.131,0,0,0,2.316-.087A5.129,5.129,0,0,1,1,9.455V9.391a5.084,5.084,0,0,0,2.328.642A5.133,5.133,0,0,1,1.74,3.185,14.564,14.564,0,0,0,12.31,8.545a5.134,5.134,0,0,1,8.741-4.678,10.285,10.285,0,0,0,3.257-1.245,5.153,5.153,0,0,1-2.255,2.838A10.3,10.3,0,0,0,25,4.651,10.425,10.425,0,0,1,22.441,7.306Z",
    transform: "translate(13 12.75)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b11b3bab86565d911e466046e7f9e557.svg";
export { ForwardRef as ReactComponent };